import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getRevenueAnalytic } from "app/services/dashboard/revenueAnalyticService";

import { BASE_URL } from "static/constants";

export const revenueAnalyticApi = createApi({
  reducerPath: "revenueAnalyticApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    getRevenueAnalytic: query({
      queryFn: () => {
        return { data: getRevenueAnalytic() };
      },
    }),
  }),
});

export const { useGetRevenueAnalyticQuery } = revenueAnalyticApi;
